import columns from '../../../../react-table/helpers/columns';

export default (data, scFromRequestBody = {}) => {
  const {
    TextColumn,
    NumberColumn,
  } = columns(data);

  const operatorColumns = [
    new TextColumn('Code', 'sendingReceivingOperator.code'),
    new TextColumn('Name', 'sendingReceivingOperator.name'),
  ];

  if (scFromRequestBody.showMailBoxes) {
    operatorColumns.push(new TextColumn('Mailbox', 'sendingReceivingOperator.mailBox'));
  }

  return [
    {
      Header: scFromRequestBody.showReceiving ? 'Receiving operator' : 'Sending operator',
      columns: operatorColumns,
    },
    {
      Header: 'PREDES',
      columns: [
        new NumberColumn('V2.0', 'predes.versionTwoZero'),
        new NumberColumn('V2.1', 'predes.versionTwoOne'),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new NumberColumn('V1.1', 'resdes.versionOneOne'),
      ],
    },
    {
      Header: 'PRECON',
      columns: [
        new NumberColumn('V1.1', 'precon.versionOneOne'),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new NumberColumn('V1.1', 'rescon.versionOneOne'),
      ],
    },
    {
      Header: 'CARDIT',
      columns: [
        new NumberColumn('V1.1', 'cardit.versionOneOne'),
        new NumberColumn('V2.0', 'cardit.versionTwoZero'),
        new NumberColumn('V1.2', 'cardit.versionOneTwo'),
        new NumberColumn('V2.1', 'cardit.versionTwoOne'),
      ],
    },
    {
      Header: 'RESDIT',
      columns: [
        new NumberColumn('V1.0', 'resdit.versionOneZero'),
        new NumberColumn('V1.1', 'resdit.versionOneOne'),
      ],
    },
    {
      Header: 'EMSEVT',
      columns: [
        new NumberColumn('V1.0', 'emsevt.versionOneZero'),
        new NumberColumn('V3.0', 'emsevt.versionThreeZero'),
      ],
    },
    {
      Header: 'EVTRPT',
      columns: [
        new NumberColumn('V1.0', 'evtrpt.versionOneZero'),
      ],
    },
    {
      Header: 'ITMATT',
      columns: [
        new NumberColumn('V1.0.0', 'itmatt.versionOneZeroZero'),
        new NumberColumn('V1.2.1', 'itmatt.versionOneTwoOne'),
        new NumberColumn('V1.5.0 E', 'itmatt.versionOneFiveZeroE'),
        new NumberColumn('V1.5.0 X', 'itmatt.versionOneFiveZeroX'),
      ],
    },
  ];
};
